import React, {useEffect, useState} from "react";
import './App.css';
import {Redirect, Route, Switch, useHistory} from 'react-router-dom';
import SignIn from "./component/signin";
import Main from "./component/Main";
import {getProducts, useProductsDispatch} from "./ProductsContext";
import {getBuyers, useBuyersDispatch} from "./BuyersContext";
import {getUser, useUserDispatch, useUserState} from "./UserContext";
import {NotPermittedView} from "./component/NotPermittedView";
import cookie from "react-cookies";
import {RECEIVER_COOKIE_KEY} from "./constant";
import {getWarehouse, useWarehouseDispatch} from "./WarehouseContext";
import {Box, CircularProgress} from "@mui/material";

export default function App() {

  const [initializing, setInitializing] = useState(true)
  const history = useHistory()

  const productDispatch = useProductsDispatch()
  const buyersDispatch = useBuyersDispatch()
  const userDispatch = useUserDispatch()
  const warehouseDispatch = useWarehouseDispatch()

  const userState = useUserState()

  useEffect(async () => {
    if (!userState.loading) {
      console.log("user state changed ", userState)
      if (userState.error != null) {
        if (userState.data != null && userState.data.code === 0) {
          history.replace('/signin')

        } else if (userState.data != null && userState.data.code === 499) {
          cookie.remove(RECEIVER_COOKIE_KEY)
          history.replace('/not-permitted')
        }
      } else {


        getProducts(productDispatch)
        getBuyers(buyersDispatch)

        await getWarehouse(warehouseDispatch)
        history.replace('/data')
      }

      setInitializing(false)
    }
  }, [userState.data])

  useEffect ( ()=> {
    localStorage.clear()
    getUser(userDispatch)

  }, []);


  return (
    <div>
      {
        initializing ?
          <Box
            sx ={{
              marginTop: (theme) => theme.spacing(18),
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center'
            }}>
            <CircularProgress color={'info'} size={34} thickness={4}/>
          </Box>
        :
          <Switch>
            <Route path='/' exact component={()=>{
              console.log('redirect')
              return <Redirect to={"/signin"}/>
            }}/>
            <Route path='/data' component={Main}/>
            <Route path='/signin' component={SignIn} />
            <Route path='/not-permitted' component={NotPermittedView} />
          </Switch>
      }
    </div>

    );

}
